import { useEffect, useState, memo } from "react"
import { Box, FormControlLabel, FormLabel, Radio, RadioGroup, Typography, TextField, Skeleton, Input } from "@mui/material"
import { translate, Translate } from "react-i18nify"


export const TestCaseComponent = memo( function TestCaseComponent({defaultCaseObject, setTestResults}){
    const [caseObj, setCaseObj] = useState(defaultCaseObject)
    const [fieldError, setFieldError] = useState({result: false, comment: false})

   

    const addCaseResult = (caseResult) => {
        setTestResults(prev => {
            const newVal = prev.map(v => {
                if(v.caseId === caseResult.caseId)
                    return caseResult
                else
                    return v
            }) 
            return newVal
        })
    }

    useEffect(() => {
        checkRequired(caseObj)
        addCaseResult(caseObj)
    },[caseObj])     

    

    const setRequired = (bool, textType) => {
        if(textType === TEXTTYPES.RESULTVALUE){
            setFieldError((prev) => {
                return {
                    ...prev, 
                    result: bool
                }
            })
        }else if(textType === TEXTTYPES.COMMENT){
            setFieldError((prev) => {
                return {
                    ...prev, 
                    comment: bool
                }
            })
        }else if(textType === TEXTTYPES.ALL){
            setFieldError({result: bool, comment: bool})
        }
    }

    const checkRequired = (c) => {
        if(c.passed == null){
            setRequired(false, TEXTTYPES.ALL)
        }else{
            setRequired(checkResultValue(c.resultValue.value) && c.passed === true, TEXTTYPES.RESULTVALUE)
            setRequired(c.comment === "" && c.passed === false, TEXTTYPES.COMMENT)
        }
    }

    const onRadioClick = (e) => {
        const newVal = e.target.value.toLowerCase() === "true"
        const compareVal = caseObj.passed === newVal ? null : newVal
        if(compareVal === false){
            setRequired(true)
        }else if( caseObj. compareVal != null){

        }
        else{
            setRequired(false)
        }
        setCaseObj((prev) => {
            return  {
                ...prev, 
                passed: compareVal
            }
        })
    }
    //This timeout is made to only change text field values after 'textChangeTimeOut' amount of time.
    //If the timeout was not present every keyboard press would result in slowing down the process
    //So for the text to update in the state, you have to not type for 1 second. 
    const textChangeTimeOut = 500
    let pressTimeout = setTimeout(() => {
    },textChangeTimeOut)

    const onTextChange = (e, textType) => {
        const newValue = e.target.value
        switch(textType){
            case TEXTTYPES.RESULTVALUE:
                setCaseObj((prev) => {
                    return  {
                        ...prev, 
                        resultValue: {
                            value: parseFloat(newValue)
                        }
                    }
                })
                break;
            case TEXTTYPES.COMMENT:
                setCaseObj((prev) => {
                    return  {
                        ...prev, 
                        comment: newValue
                    }
                })
                break;
        }
    }

    return (
        <Box 
            id="TestStep"
            sx={{ display: "flex", flexDirection: "row", width:"130%", height: 110, justifyContent: "left", alignSelf: "center", borderBottom: 1, borderColor: "neutral.300" }}
        >
            <Box id="Id" sx={{alignSelf: "center", flexGrow: 1 }} >
                <Typography
                    variant="h6"
                >
                    {translate("TestCaseId", {id: caseObj.caseId})}
                </Typography>
            </Box>
            <Box id="Passed" sx={{alignSelf: "center", flexGrow: 1}} >
                    <RadioGroup
                    row
                    value={caseObj.passed}
                    >
                        <FormControlLabel value={true} label={translate("Passed")} control={
                            <Radio
                                onClick={onRadioClick}
                            />
                        } />
                        <FormControlLabel value={false} label={translate("Failed")} control={
                            <Radio
                                onClick={onRadioClick}
                            />
                        } />
                    </RadioGroup>
            </Box>
            <Box id="Value" sx={{ flexGrow: 1 }} >
                <FormLabel>
                    <Typography> <Translate value={"ResultValue"} /></Typography>
                </FormLabel>                 
                <TextField
                    required
                    variant="outlined"
                    error={fieldError.result}
                    helperText={fieldError.result ? translate("isRequired", {value:translate("ResultValue")}) : ""}
                    onChange={(e) => onTextChange(e, TEXTTYPES.RESULTVALUE)}
                    type="number"
                    inputProps={{ min: 0 }}
                ></TextField>
            </Box>
            <Box id="comment" sx={{ flexGrow: 1, mb:1 }} >
                <FormLabel>
                    <Typography> <Translate value={"Comment"} /></Typography>
                </FormLabel>
                <TextField
                    required
                    error={fieldError.comment}
                    helperText={fieldError.comment ? translate("isRequired", {value:translate("Comment")}) : ""}
                    onChange={(e) => onTextChange(e, TEXTTYPES.COMMENT)}
                />
            </Box>
        </Box>
    )
})

export const LoadingTestCase = () => {
    const x = [0,1,2,3,4]
    return(
        <Box>
            {
                x.map((v,k) => {
                    return(
                    <Box id={k} >
                        <Skeleton animation="pulse" variant="rounded" height={80} width={"80%"} sx={{ mt: 1}}/>
                    </Box>
                    )
                })
            }
        </Box>
    )
}

export const checkResultValue = (v) => {      
    return v == null || Number.isNaN(v) || v < 0
}


const TEXTTYPES = {
    RESULTVALUE: 1,
    COMMENT: 2,
    ALL: 10
}